import { useCallback, useState } from "react";
import Navbar from "../components/site/Navbar";
import Hero from "../components/site/Hero";
import WhatWeDo from "../components/site/WhatWeDo";
import FeaturedExperience from "../components/site/FeaturedExperience";
import WhatsIncluded from "../components/site/WhatsIncluded";
import FoundingOffer from "../components/site/FoundingOffer";
import WhyCommunities from "../components/site/WhyCommunities";
import MoreWays from "../components/site/MoreWays";
import { About, ServiceArea } from "../components/site/AboutService";
import Contact from "../components/site/Contact";
import Footer from "../components/site/Footer";

export default function Landing() {
  const [prefillMessage, setPrefillMessage] = useState("");

  const schedule = useCallback((message) => {
    if (typeof message === "string" && message.length) setPrefillMessage(message);
    document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" });
  }, []);

  return (
    <div className="bg-cream min-h-screen overflow-x-hidden">
      <Navbar onSchedule={schedule} />
      <main>
        <Hero onSchedule={schedule} />
        <WhatWeDo />
        <FeaturedExperience onSchedule={schedule} />
        <WhatsIncluded />
        <FoundingOffer onSchedule={schedule} />
        <WhyCommunities />
        <MoreWays onSchedule={schedule} />
        <About />
        <ServiceArea />
        <Contact prefillMessage={prefillMessage} />
      </main>
      <Footer onSchedule={schedule} />
    </div>
  );
}
